import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { updateAddressOrder } from '../../_redux/actions/order';
import {
	addDeliveryAddress,
	editDeliveryAddress
} from '../../_redux/actions/address';

import { hotjar } from 'react-hotjar';
import FormAddress from '../../Components/FormAddress';
import NextBtn from '../../Components/NextBtn';
import NavBtn from '../../Components/NavBtn';

import Header from '../../Components/Header';

import { formUtils } from '../../utils';
import { redirectToStore } from '../../utils/stores';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import FormWrapper from '../../style/styledComponents/FormWrapper';
import BoxSize from '../../style/styledComponents/BoxSize';
import StepCounter from '../../Components/StepCounter';
import Container from '../../style/styledComponents/Container';
class Entrega extends Component {
	constructor() {
		super();

		this.formData = this.formData.bind(this);
		this.formSend = this.formSend.bind(this);
		this.errorAccept = this.errorAccept.bind(this);
		this.goBack = this.goBack.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);

		this.state = {
			error: false,
			sending: false,
			errorFunc: null
		};
	}
	componentDidMount() {
		let { Order } = this.props;
		let { loja } = this.props.match.params;
		if (!Order.data.orderId) {
			this.props.history.push(
				process.env.PUBLIC_URL + `/loja/${loja}/beneficiario`
			);
		}

		hotjar.initialize(937897, 6);
		this.handleIsComplete();
	}
	formData(data) {
		this.data = data;
	}
	formSend() {
		let checkDataValue = formUtils.checkData(this.data, ['complement']);

		if (checkDataValue) {
			this.setState({
				error: checkDataValue
			});
		} else {
			this.setState({
				sending: true
			});
		}
	}
	chainSend() {
		let { Address, Order } = this.props;
		if (this.state.sending) {
			let addressId = Address.delivery.addressId;
			let orderId = Order.data.orderId;
			let orderAddressId = Order.data.addressId;
			let addressData = formUtils.formatData(this.data);
			let { loja } = this.props.match.params;
			if (orderId && addressData && !addressId) {
				this.props.addDeliveryAddress(addressData);
			} else if (orderId && addressData && orderAddressId === addressId) {
				addressData.addressId = addressId;
				this.props.editDeliveryAddress(addressData);
				this.props.history.push(process.env.PUBLIC_URL + `/${loja}/pagamento`);
			} else if (addressId && orderId) {
				this.props.updateAddressOrder(orderId, addressId);
				this.props.history.push(process.env.PUBLIC_URL + `/${loja}/pagamento`);
			} else {
				this.setState({
					error: 'Houve um erro inesperado. Por favor, tente novamente!',
					errorFunc: () => {
						redirectToStore();
					}
				});
			}
		}
	}
	errorAccept() {
		if (this.state.errorFunc) {
			this.state.errorFunc();
		}
		this.setState({
			error: null
		});
	}
	goBack() {
		this.props.history.goBack();
	}
	handleIsComplete() {
		let sendData = {};
		for (let fieldItem in this.data) {
			sendData[fieldItem] = this.data[fieldItem].value;
		}
		let formData = sendData;
		let isIncomplete = false;

		for (let field in formData) {
			if (field === 'complement') {
			} else {
				if (formData[field] === undefined) {
					isIncomplete = true;
				}
			}
		}
		if (isIncomplete) {
			this.setState({
				isComplete: false
			});
		} else {
			this.setState({
				isComplete: true
			});
		}
	}

	render() {
		let { Address } = this.props;
		this.chainSend();

		let editData = null;

		if (Address.delivery.addressId) {
			editData = Address.delivery;
		}

		const pathArray = window.location.pathname.split('/');

		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<Container>
					<Header {...this.props} />
					<FormWrapper>
						<BoxSize>
							<div className='row '>
								<NavBtn
									goBack={this.goBack}
									goBackText={'VOLTAR'}
									goForward={false}></NavBtn>{' '}
								<StepCounter
									assinatura={false}
									assinante={false}
									pagamento={false}
									endereco={true}
								/>
							</div>
							{/* <Header {...this.props} /> */}
							<FormAddress
								onData={this.formData}
								error={this.state.error}
								errorAccept={this.errorAccept}
								initialData={editData}
								isCompleted={this.handleIsComplete}
								{...this.props}></FormAddress>{' '}
							<NavBtn
								goForward={this.formSend}
								goForwardText={'PRÓXIMO PASSO'}></NavBtn>{' '}
						</BoxSize>
					</FormWrapper>
				</Container>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{ updateAddressOrder, addDeliveryAddress, editDeliveryAddress },
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Entrega);
